import React from 'react';
import { caracteristics } from '../../constants/images';
import styles from './carBrandCharacteristics.module.scss';

interface CarBrandCharacteristicsProps {
    brand?:any
    vehicle?: any;
    publication?: any;
    selectedVersion?: string;
    className?: string;
}

const CarBrandCharacteristics: React.FC<CarBrandCharacteristicsProps> = ({
    vehicle,
    publication,
    selectedVersion,
    className,
    brand
}) => {
    const selectedVehicle = selectedVersion && publication?.vehicles
        ? publication.vehicles.find((v: any) => v._id === selectedVersion) || publication?.vehicles[0]
        : vehicle;

    const getCharacteristicValue = (name: string) => {
        if (Array.isArray(publication?.caracteristics)) {
            const characteristic = publication.caracteristics.find((c: any) => c.name === name);
            return characteristic?.value || '-';
        }
        return '-';
    };

    const carType = selectedVehicle?.type || publication?.vehicle_data?.type || getCharacteristicValue('Carrocería');
    const fuel = selectedVehicle?.fuel || publication?.vehicle_data?.fuel || getCharacteristicValue('Combustible');
    const transmission = selectedVehicle?.transmission || publication?.vehicle_data?.transmission || getCharacteristicValue('Transmisión');
    const doors = selectedVehicle?.doors || publication?.vehicle_data?.doors || getCharacteristicValue('Puertas');

    return (
        <div className={`${styles.mainCharacteristics} ${className || ''}`}>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.carType} alt="Carrocería" title="Carrocería" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Carrocería</p>
                    <p className={styles.characteristicValue}>{carType}</p>
                </div>
            </div>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.fuel} alt="Combustible" title="Combustible" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Combustible</p>
                    <p className={styles.characteristicValue}>  {fuel ? fuel.charAt(0).toUpperCase() + fuel.slice(1) : '-'}          </p>
                </div>
            </div>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.transmission} alt="Transmisión" title="Transmisión" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Transmisión</p>
                    <p className={styles.characteristicValue}>{transmission}</p>
                </div>
            </div>
            <div className={styles.characteristicItem}>
                <span className={styles.characteristicIcon}>
                    <img src={caracteristics.door} alt="Puertas" title="Puertas" />
                </span>
                <div className={styles.characteristicContent}>
                    <p className={styles.characteristicTitle}>Puertas</p>
                    <p className={styles.characteristicValue}>{doors}</p>
                </div>
            </div>
        </div>
    );
};

export default CarBrandCharacteristics;
